package com.merkost.handpass.api.dto.user

import com.merkost.handpass.api.enums.AccountStatus
import com.merkost.handpass.api.enums.ProfileVisibility
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProfileResponse(
    val id: String,
    val email: String = "",
    @SerialName("full_name") val fullName: String = "",
    @SerialName("avatar_url") val avatarUrl: String? = null,
    @SerialName("phone_number") val phoneNumber: String? = null,
    @SerialName("phone_verified") val phoneVerified: Boolean = false,
    val bio: String? = null,
    val city: String? = null,
    val country: String? = null,
    val rating: Double? = null,
    @SerialName("total_sales") val totalSales: Int = 0,
    @SerialName("total_purchases") val totalPurchases: Int = 0,
    @SerialName("is_verified") val isVerified: Boolean = false,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("account_status") val accountStatus: AccountStatus = AccountStatus.ACTIVE,
    @SerialName("profile_visibility") val profileVisibility: ProfileVisibility = ProfileVisibility.PUBLIC,
    @SerialName("show_online_status") val showOnlineStatus: Boolean = true,
    @SerialName("show_last_seen") val showLastSeen: Boolean = true,
    @SerialName("is_online") val isOnline: Boolean? = null,
    @SerialName("last_seen_at") val lastSeenAt: String? = null,
    val slug: String? = null
)
